import request from '../../lib/helpers/requestApi';
import { TFileList, ParamGetFileList } from './types';

export const getFileList = request<TFileList, ParamGetFileList>({
    method: 'dmpgBlList.getFileList',
  });